module.exports = __webpack_public_path__ + "img/recibo.3927b4e6.png";